import {EntityApiService, ApiClientService} from '@dofleini/security';

class UsersApiService extends EntityApiService {

    updateStatus = (params) => {
      return ApiClientService.post(this.getPath('/status'), params);
    };
    passwordReset = (params) => {
      return ApiClientService.post(this.getPath('/password-reset'), params);
    };

    listActive = () => {
      return ApiClientService.post(this.getPath('/search'), {
        type: 'TERM',
        field: 'status',
        value: 'ACTIVE',
      });
    };

    getOne = (_id, params) => {
      const config = {params};
      if (params?.projections && Array.isArray(params.projections)) {
        config.params = {
          ...params,
          projections: params.projections.join(',')
        };
      }
      return ApiClientService.get(this.getPath(`/${_id}`), config);
    };

    getOneFullName = (_id, params) => {
      const config = {params};
      if (params?.projections && Array.isArray(params.projections)) {
        config.params = {
          ...params,
          projections: params.projections.join(',')
        };
      }
      return ApiClientService.get(this.getPath(`/${_id}/full-name`), config);
    };

}

export default new UsersApiService('/ms-core/api/users');
